/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";

const calculateRange = (data, rowsPerPage) => {
  const range = [];
  const num = Math.ceil(data.length / rowsPerPage);
  for (let i = 1; i <= num; i++) {
    range.push(i);
  }
  return range;
};

const sliceData = (data, page, rowsPerPage) => {
  return data.slice((page - 1) * rowsPerPage, page * rowsPerPage);
};

const UseTable = (data, page) => {
  const [tableRange, setTableRange] = React.useState([]);
  const [slice, setSlice] = React.useState([]);

  const rowsPerPage = 12;

  React.useMemo(() => {
    const range = calculateRange(data, rowsPerPage);
    setTableRange([...range]);

    const tempSlice = sliceData(data, page, rowsPerPage);
    setSlice([...tempSlice]);
  }, [data, setTableRange, page, setSlice, rowsPerPage]);

  return { slice, range: tableRange };
};

export default UseTable;
